import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";
import { getErrorMessage } from "../../utils/helpers";
import {
  infoNotification,
  errorNotification,
  CREATE_CUENTA_CONTABLE,
  CREATE_CUENTA_CONTABLE_ERROR,
  CREATE_CUENTA_CONTABLE_PENDING,
  successNotification,
  ERROR,
  UPDATE_CUENTA_CONTABLE,
  DELETE_CUENTA_CONTABLE_ERROR,
  DELETE_CUENTA_CONTABLE_PENDING
} from "../../utils/notifications";
import { readMessageBack } from "../../utils/readMessageBack";

interface State {
  gettingCuentasContablesError: string;
  cuentasContables: any[];
  gettingCuentasContables: boolean;
  createCuentaContableError: object;
  creatingCuentaContable: boolean;
  cuentaContableCreated: boolean;
  reloadCuentasContables: boolean;
}
const initialState: State = {
  gettingCuentasContablesError: null,
  cuentasContables: null,
  gettingCuentasContables: false,
  createCuentaContableError: null,
  creatingCuentaContable: false,
  cuentaContableCreated: false,
  reloadCuentasContables: false
};

export default function cuentasContablesReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  // Llamada a resolver de snapshot
  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(
  state: State = initialState,
  action: IAction
): Partial<State> {
  switch (action.type) {
    case `${actionTypes.GET_CUENTAS_CONTABLES}_PENDING`: {
      //infoNotification(CREATE_CUENTA_CONTABLE_PENDING);
      return {
        ...state,
        reloadCuentasContables: false,
        gettingCuentasContablesError: null,
        gettingCuentasContables: true
      };
    }
    case `${actionTypes.GET_CUENTAS_CONTABLES}_REJECTED`: {
      errorNotification(readMessageBack(action, CREATE_CUENTA_CONTABLE_ERROR));
      return {
        ...state,
        gettingCuentasContablesError: getErrorMessage(action.payload),
        gettingCuentasContables: false
      };
    }
    case `${actionTypes.GET_CUENTAS_CONTABLES}_FULFILLED`: {
      //successNotification(CREATE_CUENTA_CONTABLE);
      return {
        ...state,
        gettingCuentasContablesError: null,
        cuentasContables: action.payload.data,
        gettingCuentasContables: false
      };
    }
    case `${actionTypes.CREATE_CUENTA_CONTABLE}_PENDING`: {
      //infoNotification(CREATE_CUENTA_CONTABLE_PENDING);
      return {
        ...state,
        createCuentaContableError: null,
        creatingCuentaContable: true
      };
    }
    case `${actionTypes.CREATE_CUENTA_CONTABLE}_REJECTED`: {
      errorNotification(readMessageBack(action, CREATE_CUENTA_CONTABLE_ERROR));
      return {
        ...state,
        createCuentaContableError: getErrorMessage(action.payload),
        creatingCuentaContable: false
      };
    }
    case `${actionTypes.CREATE_CUENTA_CONTABLE}_FULFILLED`: {
      successNotification(CREATE_CUENTA_CONTABLE);
      return {
        ...state,
        reloadCuentasContables: true,
        createCuentaContableError: null,
        creatingCuentaContable: false,
        cuentaContableCreated: true
      };
    }
    case `${actionTypes.UPDATE_CUENTA_CONTABLE}_PENDING`: {
      //infoNotification(CREATE_CUENTA_CONTABLE_PENDING);
      return {
        ...state,
        createCuentaContableError: null,
        creatingCuentaContable: true
      };
    }
    case `${actionTypes.UPDATE_CUENTA_CONTABLE}_REJECTED`: {
      errorNotification(readMessageBack(action, CREATE_CUENTA_CONTABLE_ERROR));
      return {
        ...state,
        createCuentaContableError: getErrorMessage(action.payload),
        creatingCuentaContable: false
      };
    }
    case `${actionTypes.UPDATE_CUENTA_CONTABLE}_FULFILLED`: {
      successNotification(UPDATE_CUENTA_CONTABLE);
      return {
        ...state,
        reloadCuentasContables: true,
        createCuentaContableError: null,
        creatingCuentaContable: false,
        cuentaContableCreated: true
      };
    }
    /*case `${actionTypes.DELETE_CUENTA_CONTABLE}_PENDING`: {
      infoNotification(DELETE_CUENTA_CONTABLE_PENDING);
      return {
        ...state,
        createCuentaContableError: null,
        creatingCuentaContable: false
      };
    }
    case `${actionTypes.DELETE_CUENTA_CONTABLE}_REJECTED`: {
      errorNotification(readMessageBack(action, DELETE_CUENTA_CONTABLE_ERROR));
      return {
        ...state,
        creatingCuentaContable: false
      };
    }
    case `${actionTypes.DELETE_CUENTA_CONTABLE}_FULFILLED`: {
      successNotification("Cuenta contable eliminada correctamente.");
      return {
        ...state,
        reloadCuentasContables: true
      };
    }*/
    case `${actionTypes.DISABLE_CUENTA_CONTABLE_CREATED}`: {
      return {
        ...state,
        cuentaContableCreated: false
      };
    }

    default: {
      return state;
    }
  }
}

export { initialState };
